<template>
  <div
    class="msg_w  bc_fff "
  >

    <!-- 消息列表 -->
    <div v-if="!msgDetail" class="height_100 d_flex flex_direction_col ">
      <div class="msg_h d_flex align_item_c">
        <span class="fz16 ">消息通知</span>
        <span style="margin:0 10px">|</span>
        <span class="fz12">共 {{ msgData.total }} 条</span>
      </div>

      <div
        v-if="msgData.list.length"
        class="msg_c bc_fff d_flex flex_direction_col"
      >
        <div class="read_all">
          <el-checkbox v-model="isReadAll">全部已读</el-checkbox>
        </div>
        <ul>
          <li v-for="item in msgData.list" :key="item.id" style="padding: 0 10px" class="cursor_pointer" @click="getMsgDetail(item)">

            <div class="d_flex msg_i">
              <i class="el-icon-paperclip" style="color:rgb(203, 164, 63);margin: 0 5px 0 0;" />

              <div class="fz14 d_flex flex_direction_col" style="width:100%">
                <a class=" font_w_bold"> <el-badge :is-dot="item.read===0"> {{ item.title }}</el-badge></a>
                <div style="margin:10px 0 0 0" class="d_flex justify_content_sb">
                  <span class="summary text_ellipsis c_6c6c6c">{{ item.summary }}</span>
                  <span class="">{{ item.createdAt }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div v-else class="x_y_center" style="height: 100%">
        <img src="@/assets/images/empty_icon.png" alt="">
        <span style="margin: 0 0 0 10px">暂无数据</span>
      </div>

      <div v-if="msgData.list.length" class="msg_f d_flex justify_content_c">
        <MyPagination
          change-method-name="getMsgList"
          :that="this"
          layout="prev, pager, next, jumper"
          small
          :page-sizes="[10,20,30,40,50]"
          :total="msgData.total"
          :page-info="pageInfo"
        />
      </div>

    </div>

    <!-- 消息详情 -->
    <div v-else class="msg_detail_w">
      <div class="detail_h fz16 font_w_bold d_flex justify_content_sb align_item_c">
        <span>{{ msgDetail.title }}</span>
        <span> <el-button type="text" @click="onReturnClick">返回</el-button> </span>
      </div>
      <div class="detail_c">

        <div v-html="msgDetail.content" />

        <div class="fz14 text_right" style="margin:50px 0 0 0">
          {{ msgDetail.createdAt }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/utils'
import {
  msg_info,
  msg_list,
  msg_readAll,
  msg_download
} from '@/api/user'
import MyPagination from '@/components/base/MyPagination.vue'
export default {
  components: {
    MyPagination
  },
  data() {
    return {
      pageInfo: {
        page: 1,
        rows: 10
      },
      msgData: {
        list: [
          // {
          //   title: '交易保证金缴纳通知书',
          //   summary: '尊敬的用户，您意向参加的项目编号：XM2289372，项目名称：一亩田转出，现已开始公开报名，请您准备相关报名材料.....',
          //   createdAt: '7月26日',
          //   read: 0
          // },
          // {
          //   title: '交易保证金缴纳通知书',
          //   summary: '尊敬的用户，您意向参加的项目编号：XM2289372，项目名称：一亩田转出，现已开始公开报名，请您准备相关报名材料.....',
          //   createdAt: '7月26日',
          //   read: 0
          // },
          // {
          //   title: '交易保证金缴纳通知书',
          //   summary: '尊敬的用户，您意向参加的项目编号：XM2289372，项目名称：一亩田转出，现已开始公开报名，请您准备相关报名材料.....',
          //   createdAt: '7月26日',
          //   read: 0
          // },
          // {
          //   title: '交易保证金缴纳通知书',
          //   summary: '尊敬的用户，您意向参加的项目编号：XM2289372，项目名称：一亩田转出，现已开始公开报名，请您准备相关报名材料.....',
          //   createdAt: '7月26日',
          //   read: 0
          // }
        ]
      }, // 消息列表
      isReadAll: false, // 全部已读
      msgDetail: null// 消息详情
    }
  },
  computed: {

  },
  watch: {
    async isReadAll(n) {
      if (n) {
        await msg_readAll()
        await this.getMsgList()
      }
    }
  },
  created() {
    this.getMsgList()
  },
  mounted() {
    window.downTemplate = this.downTemplate // 给动态标签绑定事件
  },
  methods: {
    // 获取消息列表
    async getMsgList() {
      const { data } = await msg_list(this.pageInfo)
      this.msgData = data
    },
    // 获取消息详情
    async getMsgDetail(item) {
      const { data } = await msg_info(item.id)
      this.msgDetail = data
    },
    // 返回
    onReturnClick() {
      this.msgDetail = null
      this.getMsgList()
    },
    // 阅读消息通知书 click
    async downTemplate(type,) {
      const res = await msg_download({ id: this.msgDetail.id, type: type })

      const url = URL.createObjectURL(new Blob([res], { type: 'application/pdf' })) // 创建文件对象地址

      // 下载文件
      downloadFile(url, this.msgDetail.title)

      URL.revokeObjectURL(url) // 释放blob文件流
    }

  }
}
</script>

<style lang="scss" scoped>
.msg_w {
    position: relative;
    overflow-y: auto;
    width: 970px;
    min-height: 505px;
    box-sizing: border-box;
    border: 1px solid #dbdbdb;
    box-shadow: 0px 2px 6px 0px rgba(204, 204, 204, 0.6);
    .msg_h{
        padding: 10px;
       border-bottom: 1px solid #dbdbdb;

    }
    .msg_c{

    }
    .read_all{
        padding: 10px ;
       border-bottom: 1px solid #dbdbdb;

    }
    .msg_i{
      padding: 10px 0;
       border-bottom: 1px solid #dbdbdb;
       .summary{
        display: inline-block;
        width: 770px;
       }
    }
    .msg_f{
        margin: 0 0 10px 0;
    }
    .detail_h{
        padding:10px 20px;
       border-bottom: 1px solid #dbdbdb;
    }
    .detail_c{
        padding: 20px;
    }
}

</style>
